import { useState, useEffect } from "react";
import { apiFetch } from "../lib/api";
import { APP_VERSION } from "../lib/constants";

/**
 * Poll /api/version on mount and every 5 minutes.
 * Stops polling once a newer version is detected.
 * @returns {{ updateAvailable: false|string }}
 */
export function useAppUpdateCheck() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const check = () => {
      if (cancelled) return;
      apiFetch("/api/version")
        .then((r) => r.json())
        .then((data) => {
          if (data.version && data.version !== APP_VERSION) {
            setUpdateAvailable(data.version);
            cancelled = true;
          }
        })
        .catch(() => {});
    };
    check();
    const interval = setInterval(check, 300000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  return { updateAvailable };
}
